import { DISPLAY_NAME, useTagContext } from '../../tag'
import type { TagScopedProps } from '../../tag.types'

import { TagLabelVariants } from './tag-label.styles'

type TagLabelProps = {
  children: React.ReactNode
}

export const TagLabel = (props: TagLabelProps) => {
  const { children, __scopeTag } = props as TagScopedProps<TagLabelProps>
  const { variants } = useTagContext(DISPLAY_NAME, __scopeTag)

  const labelText = children?.toString() ?? ''

  let percentage = 0

  const regexPattern = /\d+/g

  if (variants === 'onSale' && regexPattern.test(labelText)) {
    const [stringfiyPercentageValue] = labelText.match(regexPattern) ?? []
    const percentageValue = Number(stringfiyPercentageValue)

    if (percentageValue >= 0 && percentageValue <= 100) {
      percentage = percentageValue
    }
  }

  return (
    <p className={TagLabelVariants({ variants })} data-testid="tag-label">
      {variants === 'onSale' ? `${percentage}%` : labelText}
    </p>
  )
}
